import React, { FC } from "react";
import { Trans } from "react-i18next";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

import { makeStyles, Theme } from "@material-ui/core/styles";

interface FooterProps {}

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      backgroundColor: theme.palette.primary.dark,
    },
    title: {
      color: theme.palette.primary.main,
    },
    body: {
      color: theme.palette.primary.light,
    },
  };
});

const Footer: FC<FooterProps> = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container} id="contact" p={4}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" className={classes.title}>
            <Trans i18nKey="CONTACT.COMPANY_LABEL" />
          </Typography>
          <Typography variant="body2" className={classes.body}>
            <Trans i18nKey="CONTACT.COMPANY" />
          </Typography>{" "}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" className={classes.title}>
            <Trans i18nKey="CONTACT.TITLE" />
          </Typography>
          <Box display="flex">
            <Box mr={1}>
              <Typography variant="body2" className={classes.title}>
                <Trans i18nKey="CONTACT.ADDRESS_LABEL" />
              </Typography>
            </Box>
            <Typography variant="body2" className={classes.body}>
              <Trans i18nKey="CONTACT.ADDRESS" />
            </Typography>
          </Box>
          <Box display="flex">
            <Box mr={1}>
              <Typography variant="body2" className={classes.title}>
                <Trans i18nKey="CONTACT.EMAIL_LABEL" />
              </Typography>
            </Box>
            <Link href="mailto:mateilles718@gmail.com">
              <Typography variant="body2" className={classes.body}>
                mateilles718@gmail.com
              </Typography>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
